// extracted by mini-css-extract-plugin
module.exports = {"focusable":"accessibility_focusable__IC0f_"};